import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Input,
  InputLabel,
  TextField
} from "@mui/material";
// import { Editor as EditorTiny } from "@tinymce/tinymce-react";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { MuiTelInput } from "mui-tel-input";
import { useCallback, useEffect, useRef, useState } from "react";
import Flag from "../../../assets/img/LanguageFlags";
import { useBudgetFormContext } from "../../../context/BudgetFormContext";
import { getEmailTemplate } from '../../../services/emailService';
import { generateEmailTemplate } from "../../../utils/generateEmailTemplateDinamic";
import { printEmail } from "../../../utils/printEmail";
import BudgetRegisterCanalDiretoForm from "../BudgetRegisterCanalDiretoForm";
import BudgetRegisterForm from "../BudgetRegisterForm";
import EditorTiptap from "../../email/EditorTipTap";

const FormEmail = () => {
  const { mail, changeMail, budgets, hashBudgets, emailLanguage, setEmailLanguage, defaultDiscount, nonRefundableDiscount, formType, handleSubmit, handleSubmitBudgetRequest, nonRefundableDiscountPix, nonRefundableDiscountCard } = useBudgetFormContext();
  const [emailTemplate, setEmailTemplate] = useState();
  const editorRef = useRef(null);
  const htmlRef = useRef(mail.body);

  useEffect(() => {
  htmlRef.current = mail.body;
}, [mail.body]);

  const budget_type = formType == 'callCenter' ? 1 : 2

  const validEmail = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  const validPhone = (phone) => {
    let re = /^\(?([0-9]{2})\)?\s?(9?[0-9]{4})[-. ]?([0-9]{4})$/;
    // return re.test(phone);
    return phone.length > 7
  }

  useEffect(() => {
    const fetch = async () => {
      const email = await getEmailTemplate({fileName: `email-template-${emailLanguage}.html`})
      setEmailTemplate(email)  
      changeMail("body", generateEmailTemplate(mail.clientName, budgets, email, hashBudgets, emailLanguage, defaultDiscount, nonRefundableDiscount,nonRefundableDiscountPix, nonRefundableDiscountCard))
    
    }
  fetch();   
  },[])

  const changeTemplateLanguage = async (lang) => {
    setEmailLanguage(lang)
    const email = await getEmailTemplate({fileName: `email-template-${lang}.html`})
    setEmailTemplate(email)
    changeMail("body", generateEmailTemplate(mail.clientName, budgets, email, hashBudgets, lang, defaultDiscount, nonRefundableDiscount,nonRefundableDiscountPix, nonRefundableDiscountCard))
  }

  // useEffect(() => {
  //   const changeLanguage = async () => {
  //     const email = await getEmail({fileName: `email-template-${emailLanguage}.html`})
  //     setEmailTemplate(email) 
  //     changeMail("body", generateEmailTemplate(mail.clientName, budgets, email, hashBudgets, emailLanguage))
  //   }

  //   changeLanguage()
  // }, [emailLanguage]);

  useEffect(() => {
    changeMail("body", generateEmailTemplate(mail.clientName, budgets, emailTemplate, hashBudgets, emailLanguage, defaultDiscount, nonRefundableDiscount,nonRefundableDiscountPix, nonRefundableDiscountCard));
  }, [mail.clientName, changeMail, budgets]);

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setContent(mail.body);
    }
  }, [mail.body]);

  const handleExportPDF = useCallback(() => {
    printEmail(htmlRef.current);
  }, []);

  useEffect(() => {
    const handlePrintShortcut = (event) => {
      const isPrintShortcut =
        (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p';
      if (!isPrintShortcut) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      handleExportPDF();
    };

    window.addEventListener('keydown', handlePrintShortcut, true);
    return () => {
      window.removeEventListener('keydown', handlePrintShortcut, true);
    };
  }, [handleExportPDF]);

  return (
    <Card size={12} sx={{ height: "90vh", overflow: "scroll" }}>
      <CardContent>
        <div>
          <h4 style={{ color: "#082B49", fontSize: "16px" }}>
            Dados do Cliente
          </h4>
          <span style={{ color: "#868E96", fontSize: "14px" }}>
            Informações muito importantes, preencha com atenção
          </span>
        </div>
        <Grid container={true} spacing={3} sx={{ marginTop: "8px" }}>
          <Grid item size={12}>
            <TextField
              required
              autoComplete="new-password"
              error={mail.clientNameError}
              helperText={mail.clientNameError && 'Nome do Cliente é obrigatório'}
              id="clientName"
              name="clientName"
              label="Nome do Cliente"
              slotProps={{
                htmlInput: {
                  maxLength: 30
                }
              }}
              fullWidth
              value={mail.clientName}
              onChange={(e) => {
                !mail.clientName ? changeMail("clientNameError", true) : changeMail("clientNameError", false)
                changeMail("clientName", e.target.value)
              }}
            />
          </Grid>
          <Grid item size={6}>
            <TextField
              error={mail.clientEmailError}
              helperText={mail.clientEmailError && 'Insira um E-mail válido'}
              id="email"
              name="email"
              label="Email do Cliente"
              fullWidth
              value={mail.clientEmail}
              onChange={(e) => {
                if (mail.clientEmail && !validEmail(e.target.value))  changeMail("clientEmailError", true)
                else changeMail("clientEmailError", false)
                changeMail("clientEmail", e.target.value)
              }}
            />
          </Grid>
          <Grid item size={6}>
            {/* <TextField
              required
              autoComplete="new-password"
              error={mail.clientPhoneError}
              id="phone"
              name="phone"
              label="Telefone"
              fullWidth
              value={mail.clientPhone}
              onChange={(e) => {
                if (!mail.clientPhone || !validPhone(e.target.value))  changeMail("clientPhoneError", true)
                else changeMail("clientPhoneError", false)
                changeMail("clientPhone", e.target.value)
              }}
            /> */}
            <MuiTelInput
              required
              error={mail.clientPhoneError}
              helperText={mail.clientPhoneError && 'Insira um telefone válido'}
              label='Telefone'
              fullWidth
              id="phone"
              name="phone"
              value={mail.clientPhone}
              onChange={(value) => {
                if (!mail.clientPhone || !isValidPhoneNumber(value)) changeMail("clientPhoneError", true)
                else changeMail("clientPhoneError", false)
                changeMail("clientPhone", value)
              }}
              defaultCountry="BR"
            />
          </Grid>
          <Grid item size={6}>
            <TextField
              id="email"
              name="email"
              label="E-mail em cópia"
              fullWidth
              value={mail.copyEmail}
              onChange={(e) => changeMail("copyEmail", e.target.value)}
            />
          </Grid>

          <Grid item size={6}>
            <InputLabel htmlFor="files">Escolher Anexos</InputLabel>
            <Input
              type="file"
              inputProps={{ multiple: true }}
              //multiple
              id="file"
              name="file"
              label="E-mail em cópia"
              onChange={(e) => {
                if (e.target.files.length > 4) {
                  alert("Você pode anexar apenas 4 arquivos");
                  e.target.value = "";
                } else {
                  changeMail("attachments", e.target.files);
                }
            }}
          />
        </Grid>
		</Grid>
        <div style={{marginTop: 20}}>
          <h4 style={{ color: "#082B49", fontSize: "16px" }}>
            Dados de Controle de Orçamento
          </h4>
          <span style={{ color: "#868E96", fontSize: "14px" }}>
            Preencha informações importantes para controle do orçamento
          </span>
        </div>
        {budget_type === 1 ? 
          <BudgetRegisterForm budget={budgets[0]} handleSubmitModal={handleSubmit} handleSubmitBudget={handleSubmitBudgetRequest}/> : 
          <BudgetRegisterCanalDiretoForm budget={budgets[0]} handleSubmitModal={handleSubmit} handleSubmitBudget={handleSubmitBudgetRequest}/>}
		<div>
			<div>
				<h4 style={{ color: "#082B49", fontSize: "16px", marginTop: "24px" }}>
				Conteúdo do E-mail
				</h4>
				<span style={{ color: "#868E96", fontSize: "14px" }}>
				Revise as informações antes de enviar ao cliente
				</span>
			</div>
			<div style={{display: 'flex', gap: 10, marginBlock: 10}}>
				<IconButton 
					onClick={() => changeTemplateLanguage('pt')} 
					style={emailLanguage === 'pt' ? { background: 'rgb(0 0 0 / 18%)' } : {}}
				>
					<Flag lang={'pt'} />
				</IconButton>
				<IconButton 
					onClick={() => changeTemplateLanguage('en')} 
					style={emailLanguage === 'en' ? { background: 'rgb(0 0 0 / 18%)' } : {}}
				>
		  			<Flag lang={'en'} />
				</IconButton>
				<IconButton 
					onClick={() => changeTemplateLanguage('es')} 
					style={emailLanguage === 'es' ? { background: 'rgb(0 0 0 / 18%)' } : {}}
				>
					<Flag lang={'es'} />
				</IconButton>
			</div>
		</div>
        {/* <EditorTiny
          initialValue={mail.body}
          apiKey='lk7fq643xfhmzfl6rg6yzb78cqmsrqbk31b8rihiefcvukuy'
          onInit={(e, editor) => editorRef.current = editor}
          init={{
            height: 700,
            menubar: false,
            statusbar: false,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
            ],
            toolbar:
              "undo redo | formatselect | " +
              "bold italic backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
          // onEditorChange={(newValue, editor) =>
          //   changeMail("body", editorRef.current.getContent())
          // }
         />
        <Button
            sx={{ textTransform: "capitalize", color: "#fff", mt: 1, float: 'right' }}
            color="tertiary"
            variant="contained"
            onClick={() =>
              changeMail("body", editorRef.current.getContent())}
        >
          Salvar mudanças no e-mail
        </Button> */}
        <EditorTiptap
          value={mail.body}
          onChange={(novoHtml) => {
            htmlRef.current = novoHtml;
          }}
        />

        <Button
          sx={{ textTransform: "capitalize", color: "#fff", mt: 1, mr: 1, float: 'right' }}
          color="tertiary"
          variant="contained"
          onClick={() =>
            changeMail("body", htmlRef.current)
          }
        >
          Salvar mudanças no e-mail
        </Button>
        <Button
          sx={{ textTransform: "capitalize", mt: 1, mr: 1, float: 'right' }}
          variant="outlined"
          onClick={handleExportPDF}
        >
          Imprimir / PDF
        </Button>
      </CardContent>
    </Card>
  );
};

export default FormEmail;
